import { all, put, takeEvery } from 'redux-saga/effects'
import API from '../../../utils/api'
import { errorToaster } from '../../../utils/helper'
import { GET_CLINIC_STAFF_REQUEST, GET_MODULES_REQUEST } from '../../actions/actionTypes'
import {
  getClinicByStaffRequestFailure,
  getClinicByStaffRequestSuccess,
  getModulesRequestFailure,
  getModulesRequestSuccess,
} from '../../actions/modules/modulesAction'

// get all Clinic
function* getModuleRequestSaga(): any {
  try {
    const response = yield API.get(`/v1/auth/access_module`)
    yield put(
      getModulesRequestSuccess({
        moduleData: response?.data?.detail,
      })
    )
  } catch (e: any) {
    errorToaster(e?.meta?.message)
    yield put(
      getModulesRequestFailure({
        moduleError: e?.meta?.message,
      })
    )
  }
}

// get clinic by the staff

function* getClinicByStaffRequestSaga(payload: any): any {
  try {
    const response = yield API.get(`/v1/clinic/account/${payload.payload.staff_id}`)
    yield put(
      getClinicByStaffRequestSuccess({
        clinicByStaffData: response?.data?.detail,
      })
    )
  } catch (e: any) {
    errorToaster(e?.meta?.message)
    yield put(
      getClinicByStaffRequestFailure({
        clinicByStaffError: e?.meta?.message,
      })
    )
  }
}

function* getModuleSaga() {
  yield takeEvery(GET_MODULES_REQUEST, getModuleRequestSaga)
}

function* getClinicByStaffSaga() {
  yield takeEvery(GET_CLINIC_STAFF_REQUEST, getClinicByStaffRequestSaga)
}
export default function* moduleSaga() {
  yield all([getModuleSaga(), getClinicByStaffSaga()])
}
